module.exports = __webpack_public_path__ + "img/FJ.8d3ac341.svg";